/**
 * Quizz Wine Subscription - Vanilla JS Implementation
 * Replaces jQuery + Slick with vanilla JS + Swiper
 */

class QuizzWineSubscription {
  constructor() {
    // State
    this.currentSlide = 0;
    this.nivelDeVino = '';
    this.vinoARecibir = '';
    this.nuevosVinos = '';
    this.aboutMe = '';
    this.frecuencia = {};

    // Wine preferences
    this.winePreferences = {
      // Red wines - Basic
      redZinfandel: { valor: 'abierto', tipo: 'Zinfandel', color: 'rojo' },
      redMalbel: { valor: 'abierto', tipo: 'Malbec', color: 'rojo' },
      redCabernetSauvignon: { valor: 'abierto', tipo: 'Cabernet Sauvignon', color: 'rojo' },
      redBordeauxBlends: { valor: 'abierto', tipo: 'Bordeaux Blends', color: 'rojo' },
      redChianti: { valor: 'abierto', tipo: 'Chianti', color: 'rojo' },
      redMerlot: { valor: 'abierto', tipo: 'Merlot', color: 'rojo' },
      redPinotNoir: { valor: 'abierto', tipo: 'Pinot Noir', color: 'rojo' },
      // Red wines - Expert
      redSyrahShiraz: { valor: 'abierto', tipo: 'Syrah Shiraz', color: 'rojo' },
      redNapaCabernet: { valor: 'abierto', tipo: 'Napa Cabernet', color: 'rojo' },
      redRioja: { valor: 'abierto', tipo: 'Rioja', color: 'rojo' },
      redRhoneBlends: { valor: 'abierto', tipo: 'Rhone Blends', color: 'rojo' },
      redCaliforniaRedBlends: { valor: 'abierto', tipo: 'California Red Blends', color: 'rojo' },
      redGrenache: { valor: 'abierto', tipo: 'Grenache', color: 'rojo' },
      redCaliforniaPinotNoir: { valor: 'abierto', tipo: 'California Pinot Noir', color: 'rojo' },
      redBurgundy: { valor: 'abierto', tipo: 'Burgundy', color: 'rojo' },
      // White wines - Basic
      whiteChardonnay: { valor: 'abierto', tipo: 'Chardonnay', color: 'blanco' },
      whiteSauvignonBlanc: { valor: 'abierto', tipo: 'Sauvignon Blanc', color: 'blanco' },
      whitePinotGrigio: { valor: 'abierto', tipo: 'Pinot Grigio', color: 'blanco' },
      whiteRiesling: { valor: 'abierto', tipo: 'Riesling', color: 'blanco' },
      whiteMoscato: { valor: 'abierto', tipo: 'Moscato', color: 'blanco' },
      // White wines - Expert
      whiteViognier: { valor: 'abierto', tipo: 'Viognier', color: 'blanco' },
      whiteCheninBlanc: { valor: 'abierto', tipo: 'Chenin Blanc', color: 'blanco' },
      whiteCrispChardonnay: { valor: 'abierto', tipo: 'Crisp Chardonnay', color: 'blanco' },
      whiteGrunerVeltliner: { valor: 'abierto', tipo: 'Gruner Veltliner', color: 'blanco' },
      whiteAlbarino: { valor: 'abierto', tipo: 'Albarino', color: 'blanco' }
    };

    // Variant mappings
    this.redVariants = {
      '765': '44128798081252',
      '850': '44128798114020',
      '935': '44128798146788',
      '1020': '44128798179556',
      '1300': '44128798212324'
    };

    this.whiteVariants = {
      '765': '44128800309476',
      '850': '44128800342244',
      '935': '44128800375012',
      '1020': '44128800407780',
      '1300': '44128800440548'
    };

    this.frequencyPlans = {
      'mensual': '3769860324',
      'cadaDosMeses': '3769893092',
      'cadaTresMeses': '3769925860'
    };

    this.swiper = null;

    this.init();
  }

  init() {
    this.initSwiper();
    this.bindEvents();
    this.clearCart();
  }

  initSwiper() {
    this.swiper = new Swiper('.quizz_questions', {
      slidesPerView: 1,
      spaceBetween: 0,
      allowTouchMove: false,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      speed: 800,
      autoHeight: true
    });
  }

  bindEvents() {
    // Navigation buttons
    document.querySelector('.pickedQuizWrap_prev')?.addEventListener('click', () => this.prevSlide());
    document.querySelector('.pickedQuizWrap_next')?.addEventListener('click', () => this.nextSlide());

    // Nivel en vino fieldset
    document.getElementById('nivelEnVino')?.addEventListener('change', (e) => {
      this.handleNivelEnVinoChange(e.target.value);
    });

    // Vino a recibir fieldset
    document.getElementById('vinoARecibir')?.addEventListener('change', (e) => {
      this.handleVinoARecibirChange(e.target.value);
    });

    // Nuevos vinos fieldset
    document.getElementById('nuevosVinos')?.addEventListener('change', (e) => {
      this.handleNuevosVinosChange(e.target.value);
    });

    // Wine preference changes
    document.querySelectorAll('.pickedQuizQuestion-winePreference input[type="radio"]').forEach(input => {
      input.addEventListener('change', (e) => {
        const wineName = e.target.name;
        if (this.winePreferences[wineName]) {
          this.winePreferences[wineName].valor = e.target.value;
        }
      });
    });

    // Frecuencia fieldset
    document.getElementById('frecuencia')?.addEventListener('change', (e) => {
      const value = e.target.value;
      this.frecuencia = {
        nota: value,
        idPlan: this.frequencyPlans[value]
      };
    });

    // About me textarea
    document.querySelector('.aboutMe_textarea')?.addEventListener('input', (e) => {
      this.aboutMe = e.target.value;
    });
  }

  prevSlide() {
    if (this.swiper.activeIndex === 0) {
      window.location.replace("/pages/picked");
      return;
    }
    this.swiper.slidePrev();
  }

  nextSlide() {
    // Toggle expert wines visibility
    if (this.nivelDeVino === 'novato') {
      document.querySelectorAll('.vinos_tintos_experto, .vinos_blancos_experto').forEach(el => {
        el.style.display = 'none';
      });
    } else {
      document.querySelectorAll('.vinos_tintos_experto, .vinos_blancos_experto').forEach(el => {
        el.style.display = 'block';
      });
    }

    // Capture current slide data
    this.captureSlideData();

    // Check for special actions
    if (this.swiper.activeIndex === 4) {
      this.updatePreferenceSummary();
    }

    if (this.swiper.activeIndex === 6) {
      this.clearCart();
    }

    if (this.swiper.activeIndex === 7) {
      this.realizarSuscripcion();
      return;
    }

    this.swiper.slideNext();
  }

  captureSlideData() {
    const currentSlide = document.querySelector('.swiper-slide-active');
    if (!currentSlide) return;

    const fieldsets = currentSlide.querySelectorAll('fieldset');

    fieldsets.forEach(fieldset => {
      const checkedInput = fieldset.querySelector('input:checked');
      if (!checkedInput) return;

      switch (checkedInput.name) {
        case 'nivelEnVino':
          this.nivelDeVino = checkedInput.value;
          break;
        case 'vinoARecibir':
          this.vinoARecibir = checkedInput.value;
          break;
        case 'nuevosVinos':
          this.nuevosVinos = checkedInput.value;
          break;
        case 'frecuencia':
          this.frecuencia = {
            nota: checkedInput.value,
            idPlan: this.frequencyPlans[checkedInput.value]
          };
          break;
        default:
          if (this.winePreferences[checkedInput.name]) {
            this.winePreferences[checkedInput.name].valor = checkedInput.value;
          }
          break;
      }
    });
  }

  handleNivelEnVinoChange(value) {
    this.nivelDeVino = value;
    const messages = {
      'novato': '¡Todos empezamos por algún lado! Tu somm personal está aquí para guiarte.',
      'intermedio': '¡Impresionante! Tu somm personal te ayudará a descubrir algunos de tus favoritos nuevos e interesantes.',
      'avanzado': '¡Nuestra gente! Tu somm personal está listo para divertirse.'
    };
    document.getElementById('q1_message').textContent = messages[value] || '';
  }

  handleVinoARecibirChange(value) {
    this.vinoARecibir = value;
    const messages = {
      'tinto': '¡Excelente! Siempre puedes agregar blancos más adelante.',
      'blanco': '¡Excelente! Siempre puedes agregar tinto más adelante.',
      'tintoYblanco': '¡Excelente! Configurarás la mezcla exacta más adelante.'
    };
    document.getElementById('q2_message').textContent = messages[value] || '';
  }

  handleNuevosVinosChange(value) {
    this.nuevosVinos = value;
    const messages = {
      'mismos': 'Te entendemos. Nos ajustaremos a los estilos que te gusten.',
      'mezcla': 'Bien, incursionemos. Te enviaremos una combinación de estilos nuevos y familiares.',
      'nuevos': '¡Excelente! Exploraremos nuevos estilos de vino.'
    };
    document.getElementById('q3_message').textContent = messages[value] || '';
  }

  updatePreferenceSummary() {
    const likesContainer = document.getElementById('likes');
    const dislikesContainer = document.getElementById('disLikes');

    if (!likesContainer || !dislikesContainer) return;

    likesContainer.innerHTML = '';
    dislikesContainer.innerHTML = '';

    // Basic wines only (expert wines shown separately)
    const basicWines = [
      'redZinfandel', 'redMalbel', 'redCabernetSauvignon', 'redBordeauxBlends',
      'redChianti', 'redMerlot', 'redPinotNoir',
      'whiteChardonnay', 'whiteSauvignonBlanc', 'whitePinotGrigio',
      'whiteRiesling', 'whiteMoscato'
    ];

    basicWines.forEach(wineName => {
      const wine = this.winePreferences[wineName];
      if (!wine) return;

      const itemHtml = `
        <div class="pickedPreferences_itemWrap">
          <i class="icon icon-thumb-up pickedPreferences_icon pickedPreferences_icon-${wine.color}"></i>
          <span class="pickedPreferences_item">${wine.tipo}</span>
        </div>
      `;

      if (wine.valor === 'meGusta') {
        likesContainer.insertAdjacentHTML('beforeend', itemHtml);
      } else if (wine.valor === 'noMeGusta') {
        dislikesContainer.insertAdjacentHTML('beforeend', itemHtml);
      }
    });
  }

  generateNotesCart() {
    const wp = this.winePreferences;
    return `
      1.- ¿Dónde estás en tu viaje del vino?: ${this.nivelDeVino},
      2.- ¿Qué tipos de vino te gustaría recibir?: ${this.vinoARecibir},
      ¿Qué opinas de estos vinos tintos?.
      1.- Zinfandel: ${wp.redZinfandel.valor},
      2.- Malbec: ${wp.redMalbel.valor},
      3.- Cabernet Sauvignon: ${wp.redCabernetSauvignon.valor},
      4.- Bordeaux Blends: ${wp.redBordeauxBlends.valor},
      5.- Chianti: ${wp.redChianti.valor},
      6.- Merlot: ${wp.redMerlot.valor},
      7.- Pinot Noir: ${wp.redPinotNoir.valor}.
      Vinos Tintos para expertos:
      8.- Syrah Shiraz: ${wp.redSyrahShiraz.valor},
      9.- Napa Cabernet: ${wp.redNapaCabernet.valor},
      10.- Rioja: ${wp.redRioja.valor},
      11.- Rhone Blends: ${wp.redRhoneBlends.valor},
      12.- California Red Blends: ${wp.redCaliforniaRedBlends.valor},
      13.- Grenache: ${wp.redGrenache.valor},
      14.- California Pinot Noir: ${wp.redCaliforniaPinotNoir.valor},
      15.- Burgundy: ${wp.redBurgundy.valor}.
      ¿Qué opinas de estos vinos blancos?.
      1.- Chardonnay: ${wp.whiteChardonnay.valor},
      2.- Sauvignon Blanco: ${wp.whiteSauvignonBlanc.valor},
      3.- Pinot Grigio: ${wp.whitePinotGrigio.valor},
      4.- Riesling: ${wp.whiteRiesling.valor},
      5.- Moscato: ${wp.whiteMoscato.valor}.
      Vinos Blancos para expertos:
      6.- Viognier: ${wp.whiteViognier.valor},
      7.- Chenin Blanc: ${wp.whiteCheninBlanc.valor},
      8.- Crisp Chardonnay: ${wp.whiteCrispChardonnay.valor},
      9.- Gruner Veltliner: ${wp.whiteGrunerVeltliner.valor},
      10.- Albarino: ${wp.whiteAlbarino.valor}.
      Cuéntanos sobre tu nivel de aventura. ¿Te gustaría quedarte con los vinos que te gustan o aventurarte a probar vinos nuevos?
      1.- Le gustaria recibir: ${this.nuevosVinos}
      ¿Con qué frecuencia le gustaría recibir tus vinos nuevos?
      1.- Con una frecuencia de: ${this.frecuencia.nota}
      Comentarios adicionales:
      ${this.aboutMe}
    `;
  }

  async realizarSuscripcion() {
    const qtyRed = parseInt(document.getElementById('valueQtyRed').textContent);
    const qtyWhite = parseInt(document.getElementById('valueQtyWhite').textContent);
    const variantRedPrice = document.getElementById('valuePriceRed').textContent;
    const variantWhitePrice = document.getElementById('valuePriceWhite').textContent;

    const productVariantRed = this.redVariants[variantRedPrice] || '';
    const productVariantWhite = this.whiteVariants[variantWhitePrice] || '';

    const formData = {
      items: [
        {
          id: productVariantRed,
          quantity: qtyRed,
          selling_plan: this.frecuencia.idPlan
        },
        {
          id: productVariantWhite,
          quantity: qtyWhite,
          selling_plan: this.frecuencia.idPlan
        }
      ]
    };

    try {
      await fetch("/cart/add.json", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      await fetch("/cart/update.json", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ note: this.generateNotesCart() })
      });

      window.location.href = "/checkout";
    } catch (err) {
      console.error('Error realizando suscripción:', err);
    }
  }

  async clearCart() {
    try {
      await fetch(window.Shopify.routes.root + 'cart/clear.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json'
        }
      });
    } catch (err) {
      console.error('Error clearing cart:', err);
    }
  }
}

// Quantity and Price Controls
const QuizzControls = {
  MIN_TOTAL_BOTTLES: 3,
  MAX_BOTTLES_PER_TYPE: 6,
  // The 5 real winred prices; not evenly spaced, so +/- walks this list by index.
  POINTS: [765, 850, 935, 1020, 1300],

  // Previous/next real price (clamped at the ends).
  neighbors(price) {
    const i = this.POINTS.indexOf(price);
    return [this.POINTS[Math.max(i - 1, 0)], this.POINTS[Math.min(i + 1, this.POINTS.length - 1)]];
  },

  getValues() {
    return {
      qtyRed: parseInt(document.getElementById('valueQtyRed')?.textContent || '3'),
      qtyWhite: parseInt(document.getElementById('valueQtyWhite')?.textContent || '3'),
      priceRed: parseInt(document.getElementById('valuePriceRed')?.textContent || '850'),
      priceWhite: parseInt(document.getElementById('valuePriceWhite')?.textContent || '850')
    };
  },

  updateDisplay(values) {
    document.getElementById('valueQtyRed').textContent = values.qtyRed;
    document.getElementById('valueQtyWhite').textContent = values.qtyWhite;
    document.getElementById('valuePriceRed').textContent = values.priceRed;
    document.getElementById('valuePriceWhite').textContent = values.priceWhite;

    const totalRed = values.qtyRed * values.priceRed;
    const totalWhite = values.qtyWhite * values.priceWhite;
    const totalPurchase = totalRed + totalWhite;

    document.getElementById('totalPriceRed').textContent = totalRed;
    document.getElementById('totalPriceWhite').textContent = totalWhite;
    document.getElementById('totalPurchase').textContent = totalPurchase;

    // Total range = each type's bottles at its previous/next real price (same as the per-row "Rango").
    const [loRed, hiRed] = this.neighbors(values.priceRed);
    const [loWhite, hiWhite] = this.neighbors(values.priceWhite);
    document.querySelector('.pickedSettingsPriceRange_min').textContent = values.qtyRed * loRed + values.qtyWhite * loWhite;
    document.querySelector('.pickedSettingsPriceRange_max').textContent = values.qtyRed * hiRed + values.qtyWhite * hiWhite;

    this.updateBottleDisplay(values);
  },

  updateBottleDisplay(values) {
    const bottlesRed = document.getElementById('bottlesRes');
    const bottlesWhite = document.getElementById('bottlesWhite');

    if (bottlesRed) {
      bottlesRed.innerHTML = '';
      for (let i = 0; i < values.qtyRed; i++) {
        bottlesRed.insertAdjacentHTML('beforeend', '<span class="pickedSettingsGrid_image wine-red"></span>');
      }
    }

    if (bottlesWhite) {
      bottlesWhite.innerHTML = '';
      for (let i = 0; i < values.qtyWhite; i++) {
        bottlesWhite.insertAdjacentHTML('beforeend', '<span class="pickedSettingsGrid_image wine-white"></span>');
      }
    }
  },

  adjustQuantities(type, operation) {
    const values = this.getValues();
    const isRed = type === 'red';
    const qtyKey = isRed ? 'qtyRed' : 'qtyWhite';
    const otherQtyKey = isRed ? 'qtyWhite' : 'qtyRed';

    if (operation === 'plus') {
      if (values[qtyKey] < this.MAX_BOTTLES_PER_TYPE) {
        values[qtyKey]++;
        const total = values.qtyRed + values.qtyWhite;
        if (total > this.MAX_BOTTLES_PER_TYPE) {
          values[otherQtyKey] = Math.max(0, values[otherQtyKey] - 1);
        }
      }
    } else {
      if (values[qtyKey] > 0) {
        values[qtyKey]--;
        const total = values.qtyRed + values.qtyWhite;
        if (total < this.MIN_TOTAL_BOTTLES) {
          values[otherQtyKey] = this.MIN_TOTAL_BOTTLES - values[qtyKey];
        }
      }
    }

    this.updateDisplay(values);
  },

  adjustPrice(type, operation) {
    const values = this.getValues();
    const priceKey = type === 'red' ? 'priceRed' : 'priceWhite';

    const i = this.POINTS.indexOf(values[priceKey]);
    const next = i + (operation === 'plus' ? 1 : -1);
    if (i !== -1 && next >= 0 && next < this.POINTS.length) {
      values[priceKey] = this.POINTS[next];
    }

    const rangeElement = type === 'red' ? document.getElementById('rangeRed') : document.getElementById('rangeWhite');
    if (rangeElement) {
      const [lo, hi] = this.neighbors(values[priceKey]);
      rangeElement.textContent = `$${lo} - $${hi} Rango`;
    }

    this.updateDisplay(values);
  }
};

// Global functions for onclick handlers
function qtyRed(operation) {
  QuizzControls.adjustQuantities('red', operation);
}

function qtyWhite(operation) {
  QuizzControls.adjustQuantities('white', operation);
}

function variantRed(operation) {
  QuizzControls.adjustPrice('red', operation);
}

function variantWhite(operation) {
  QuizzControls.adjustPrice('white', operation);
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new QuizzWineSubscription();
  // updateDisplay otherwise only runs on +/-; fill the price range from the markup's defaults.
  QuizzControls.updateDisplay(QuizzControls.getValues());
});
